import { Box, Button, Checkbox, FormControl, FormControlLabel, FormGroup, InputLabel, MenuItem, Select, Stack } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react'
import CancelIcon from '@mui/icons-material/Cancel';
import SendIcon from '@mui/icons-material/Send';
import { MuiTelInput } from 'mui-tel-input';
import { useAppStore } from '../../../../../store/appStore.tsx';
import { updateConfigAlarma } from '../../../../../actions/alarmaActions.js';
import { useValue } from '../../../../../context/ContextProvider.js';


//Opciones de configuracion de SMS que van como chekbox
/*
const opcionesCel = [
    "Habilitacion",
    "Notificar Armada",
    "Notificar Desarmada",
    "Notificar Alarmada",
    "Notifica Bateria",
    "Permitir Armar",
    "Permitir Desarmar",
];
*/

//name: es el nombre del campo - label: la descripcion que se muestra en el formulario
const opcionesCel = [
    {name: "hab", label: "Habilitacion"},
    {name: "notifArm", label: "Notificar Armada"},
    {name: "notifDesarm", label: "Notificar Desarmada"},
    {name: "notifAlarm", label: "Notificar Alarmada"},
    {name: "notifBat", label: "Notifica Bateria"},
    {name: "permitArm", label: "Permitir Armar"},
    {name: "permitDisarm", label: "Permitir Desarmar"},
    {name: "permitConsulta", label: "Permitir Consulta"},
];

//Clase que define los names de configuracion de cada celular
class Celular {
    constructor(instancia) {
        this.id = instancia;
        this.numero = '+591';

        opcionesCel.forEach((opt) => {
            this[opt.name] = 0;    //this[label] hace que cada una de las opcionesCel se generen como this.opcionCel[index] 
        });
    }
}

//Inicializa un array de celulares
const NUM_CELULARES = 4;
var celIni = [];
for (let i = 0; i < NUM_CELULARES; i++) {
    celIni.push(new Celular(i));
}

const smsIni = {
    intevaloIni: 180,
    intervaloInc: 60,
    habConPass: 1,
    numCelulares: NUM_CELULARES,
    celulares: celIni
}

const ConfigSms = ({smsConfig, setSmsConfig}) => {

    const { dispatch } = useValue();
    //const currentUser = useAppStore(appStore => appStore.currentUser);
    const { currentUser, startLoading, endLoading } = useAppStore(appStore => appStore);
    const [estado, setEstado] = useState('---');
    //const [indexSeleccionado, setIndexSeleccionado] = useState(0);
    const [celData, setCelData] = useState(celIni);             //Maneja los datos de los celulares
    //const [smsData, setSmsData] = useState(smsIni);             //Maneja los datos de los celulares
    const [celSeleccionado, setCelSeleccionado] = useState(0);  //Comienza con el primero

    //console.log(smsConfig.configId);

    useEffect(() => {
        //console.log('🟢 Montado');
        //console.log(smsIni);
        //console.log("smsConfig: ", smsConfig);
        

        //Solo se actualiza la configuracion a datos default si los datos recien se recibieron o no hay configuracion en la base de datos
        //if(smsConfig.justRx === true && smsConfig.configId === 0) {
        if(Object.keys(smsConfig.jsonConfig).length === 0) {    
            //console.log("Inicializando celData");
            //console.log("celIni: ", celIni);
            //console.log("smsIni: ", smsIni);
            setCelData(celIni);
            setSmsConfig({...smsConfig, jsonConfig: smsIni});
            setEstado("No existe configuración SMS en la Base de datos.")
        } else {
            setCelData(smsConfig.jsonConfig.celulares);
            //setSmsData(smsConfig.jsonConfig);
            setEstado("Configuración SMS recuperada de la Base de datos.")
        }

        return () => {
            //console.log('🔴 El componente se desmontó');
            // Aquí va tu lógica de limpieza
        };
    }, [])

    //Handlers del formulario
    const handleCelChange = (e) => {
        setCelSeleccionado(e.target.value);
    };

    const handleNumeroChange = (value) => {
        const updatedCelData = celData.map((cel) => {
            if (cel.id === celSeleccionado) {
                return {
                    ...cel,
                    numero: value,
                };
            }
            return cel;
        });
        setCelData(updatedCelData);
        const updatedJsonConfig = {...smsConfig.jsonConfig, celulares: updatedCelData}
        //setSmsConfig({...smsConfig, jsonConfig: updatedCelData});
        setSmsConfig({...smsConfig, jsonConfig: updatedJsonConfig});
        //console.log({...smsConfig, jsonConfig: updatedJsonConfig});
    }

    const handleCheckboxChange = (e) => {
        const updatedCelData = celData.map((cel) => {
            if (cel.id === celSeleccionado) {
                return {
                    ...cel,
                    [e.target.name]: e.target.checked ? 1 : 0,
                };
            }
            return cel;
        });
        setCelData(updatedCelData);
        const updatedJsonConfig = {...smsConfig.jsonConfig, celulares: updatedCelData}
        //setSmsConfig({...smsConfig, jsonConfig: updatedCelData});
        setSmsConfig({...smsConfig, jsonConfig: updatedJsonConfig});
        //console.log({...smsConfig, jsonConfig: updatedJsonConfig});
    };

    /* Manejo de los botones de cancelar y enviar */
    const handleSubmit = async (event) => {
        event.preventDefault();
        startLoading();
        //console.log({currentUser, celData});
        setEstado('Enviando configuración');
        //const updateResult = await updateConfigAlarma (currentUser, smsConfig.device.devId, "CMD_SET_CONFIG_SMS", celData, dispatch); 
        const updateResult = await updateConfigAlarma (currentUser, smsConfig.device.devId, "CMD_SET_CONFIG_SMS", smsConfig.jsonConfig, dispatch); 
        //console.log(updateResult);
        //setConfigId(updateResult ? updateResult.insertId : 0);  //Porque cuando se hace una nueva configuracion, el id del registro se devuelve como insertId

        setSmsConfig({...smsConfig, configId: updateResult ? updateResult.insertId : 0});

        setEstado(updateResult?.insertId ? 'Hecho' : 'Error');
        endLoading();
    }

    const handleLog = () => {
    }

    const handleSendForm = () => {
    }


    //Variable que mantiene los datos del celular seleccionado. 
    const celularActual = celData.find((c) => c.id === celSeleccionado);
    //console.log("celularActual", celularActual);

    return (
        <Box sx={{ width: { xs: '100%', sm: '70%', md: '50%', lg: '45%', xl: '40%' }}}>
            <form onSubmit={(event) => handleSubmit(event)}>

                <Box component="fieldset" marginBottom={2} sx={{ width: '100%', color: "#555", borderRadius: 1, borderWidth: 1, borderColor: "#ccc", bgcolor: "#fff" }}>
                    <legend style={{ paddingLeft: 6, paddingRight: 6, fontSize: 14, color: '#1976d2', fontWeight: 'bold' }}>
                        CELULARES / SMS
                    </legend>

                    <FormControl fullWidth sx={{ mb: 3 }}>
                        <InputLabel>Selecciona un celular</InputLabel>
                        <Select
                            size="small"
                            value={celSeleccionado}
                            label="Selecciona un celular"
                            onChange={handleCelChange}
                        >
                            {celData.map((cel) => (
                                <MenuItem key={cel.id} value={cel.id}>
                                    Celular {cel.id + 1}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                    <MuiTelInput
                        //disabled 
                        fullWidth
                        name="numero"
                        size="small"
                        value={celularActual.numero} 
                        label='Numero'
                    //sx={{ width: '60%' }} 
                    onChange={handleNumeroChange} 
                    />

                    {celularActual && (
                        <FormGroup>
                            {opcionesCel.map((opc) => (
                                <FormControlLabel sx={{ mb: -1, ml: 1 }} // mb maneja la distancia entre checkboxes (-1 * 8px = -8px)
                                    key={opc.name}
                                    control={
                                        <Checkbox
                                            disabled={ !celularActual["hab"] && opc.name !== "hab"}
                                            name={opc.name}
                                            size="small"
                                            checked={!!celularActual[opc.name]}
                                            onChange={handleCheckboxChange}
                                        />
                                    }
                                    label={opc.label}
                                />
                            ))}
                        </FormGroup>
                    )}


                </Box>


                {/* Botones de control */}
                <Stack direction='row' paddingBottom={4} spacing={2} justifyContent='end'>

                    <Button onClick={handleLog} variant="outlined" startIcon={<CancelIcon />}>
                        Cancelar
                    </Button>
                    <Button onClick={handleSendForm} type='submit' variant='contained' startIcon={<SendIcon />}>
                        Enviar
                    </Button>
                </Stack>

            </form>
            <Box >
                <hr />
                <h4>Estado: {estado}</h4>
                <p>configId: {smsConfig.configId}</p>
            </Box>
        </Box>
    )
}

export default ConfigSms